module.exports = "https://coursera_assets.s3.amazonaws.com/images/4faa5d9ea4a7e69298d65c0b76a66c17.jpg";